<template>
  <div class="underLease-group-dashboard">
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane
        v-if="judgePermission('order_data_board_lease_tenant')"
        label="租赁中订单"
        name="1"
      />
      <el-tab-pane
        v-if="judgePermission('order_data_board_risk_tenant')"
        label="风控订单"
        name="2"
      />
    </el-tabs>

    <component
      v-if="judgePermission(currentComponent.permission)"
      :is="currentComponent.component"
    />
  </div>
</template>
<script>
import LeaseOrders from './leaseOrders.vue'
import RiskOrders from './riskOrders.vue'

const TABS = ['1', '2']

export default {
  components: {
    LeaseOrders,
    RiskOrders,
  },
  data() {
    const { tab } = this.$route.query
    const activeName = TABS.includes(tab) ? tab : '0'

    return {
      activeName,
      componentMap: {
        [TABS[0]]: {
          component: 'LeaseOrders',
          permission: 'order_data_board_lease_tenant',
        },
        [TABS[1]]: {
          component: 'RiskOrders',
          permission: 'order_data_board_risk_tenant',
        },
      },
    }
  },
  computed: {
    currentComponent() {
      return this.componentMap[this.activeName]
    },
  },
  methods: {
    handleTabClick(tab) {
      this.activeName = tab.name
    },
  },
  created() {
    const { tab } = this.$route.query
    if (TABS.includes(tab)) return

    if (this.judgePermission('order_data_board_lease_tenant')) {
      this.activeName = TABS[0]
    } else if (this.judgePermission('order_data_board_risk_tenant')) {
      this.activeName = TABS[1]
    }
  },
}
</script>
<style lang="scss" scoped>
.tabs {
  margin-top: -16px;
}
</style>
